import { useState } from 'react';

import { MfaCodeField } from '@playbooks/components/auth/mfa-code-field';
import { useStore } from '@playbooks/contexts';
import { useAction } from '@playbooks/hooks';
import { Button } from '@playbooks/ui/components/button';
import { Field, FieldDescription, FieldLabel } from '@playbooks/ui/components/field';
import { Input } from '@playbooks/ui/components/input';

const MfaChallengeForm = ({ challenge, onNext, onCancel = undefined, allowRecovery = false }) => {
	const [code, setCode] = useState('');
	const [recovery, setRecovery] = useState(false);
	const store = useStore();

	// Actions
	const [onVerify, verifyTask] = useAction(async () => {
		const response = await store.createRecord({
			url: '/auth/mfa/verify',
			data: recovery
				? { challengeId: challenge.challengeId, recoveryCode: code }
				: { challengeId: challenge.challengeId, code, remember: true },
		});
		await onNext(response.data);
	});
	const [onResend, resendTask] = useAction(async () => {
		await store.createRecord({ url: '/auth/mfa/resend', data: { challengeId: challenge.challengeId } });
	});

	// Methods
	const onSubmit = event => {
		event.preventDefault();
		onVerify();
	};

	// Render
	return (
		<form onSubmit={onSubmit} className='flex-column gap-4'>
			<div>
				<h2 className='type-heading'>Two-factor authentication</h2>
				<p className='type-body text-foreground-body'>
					{recovery ? 'Enter one of your recovery codes.' : `Enter the code sent to ${challenge.maskedPhone}.`}
				</p>
			</div>
			{recovery ? (
				<Field>
					<FieldLabel>Recovery code</FieldLabel>
					<Input
						value={code}
						autoComplete='one-time-code'
						onChange={event => setCode(event.target.value.toUpperCase())}
					/>
					<FieldDescription>Codes expire after ten minutes.</FieldDescription>
				</Field>
			) : (
				<MfaCodeField
					label='Verification code'
					value={code}
					description='Codes expire after ten minutes.'
					onChange={setCode}
				/>
			)}
			<div className='flex-column gap-2'>
				<Button type='submit' size='lg' isLoading={verifyTask.running} disabled={recovery ? !code : code.length !== 6}>
					Verify
				</Button>
				{allowRecovery && (
					<Button
						type='button'
						variant='outline'
						onClick={() => {
							setCode('');
							setRecovery(!recovery);
						}}>
						{recovery ? 'Use an SMS code' : 'Use a recovery code'}
					</Button>
				)}
				{!recovery && (
					<Button type='button' variant='ghost' isLoading={resendTask.running} onClick={onResend}>
						Send another code
					</Button>
				)}
				{onCancel && (
					<Button type='button' variant='ghost' onClick={onCancel}>
						Cancel
					</Button>
				)}
			</div>
		</form>
	);
};

export { MfaChallengeForm };
